import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";

const SITE_TYPES = ["Depot", "Maintenance Hangar", "Yard", "Wash Bay", "Laydown Area", "Other"];

export default function Sites() {
  const [customerOpts, setCustomerOpts] = useState([]);
  const [idToName, setIdToName] = useState({});

  useEffect(() => {
    api.get("/customers").then(({ data }) => {
      setCustomerOpts(data.map((c) => ({ value: c.id, label: c.name })));
      setIdToName(Object.fromEntries(data.map((c) => [c.id, c.name])));
    }).catch(() => {});
  }, []);

  return (
    <CrudPage
      title="Sites"
      subtitle="Company locations — depots, maintenance hangars, yards"
      endpoint="/sites"
      columns={[
        { key: "name", label: "Site Name", render: (v) => <span className="font-semibold">{v}</span> },
        { key: "site_type", label: "Type" },
        { key: "address", label: "Address" },
        { key: "contact_name", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "customer_id", label: "Customer", render: (v) => idToName[v] || "—" },
      ]}
      fields={[
        { key: "name", label: "Site Name", required: true, full: true },
        { key: "site_type", label: "Site Type", type: "select", options: SITE_TYPES, default: "Depot" },
        { key: "address", label: "Address", full: true },
        { key: "contact_name", label: "Contact Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "customer_id", label: "Linked Customer (optional)", type: "select" },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
      dynamicOptions={{ customer_id: customerOpts }}
    />
  );
}
